<template>
  <v-data-table
    :headers="headers"
    :items="reservations"
    :page.sync="pagination.page"
    :items-per-page.sync="paginationReservation.rowsPerPage"
    :loading="loading"
    loading-text=""
    :search="searchFromParent"
    :items-per-page-text="rowsPerPageText"
    :items-per-page-items="rowsPerPageItems"
    :header-props="{ sortIcon }"
    :footer-props="{ prevIcon, nextIcon,'items-per-page-options': rowsPerPageItems }"
    :class="{ 'no-show-permission': !userHasPermissionTo('show') }"
    @pagination="setRowsOnLocalStorage(dataTableReservationId,paginationReservation.rowsPerPage)"
  >
    <template v-slot:item="props">
      <reservations-table-row
        @click.native="openReservation(props.item)"
        :reservation="props.item"
        :can-open-reservation="userHasPermissionTo('show')"
      />
    </template>

    <template v-slot:pageText="props">
      {{ props.pageStart }} - {{ props.pageStop }} {{ $t("tables.Of") }}
      {{ props.itemsLength }}
    </template>

    <template v-slot:no-results>
      <data-table-no-results :search="searchFromParent" />
    </template>

    <template v-slot:no-data>
      <div v-if="loading" />

      <div v-else-if="isNormalUser && !workspaceUuid">
        {{ $t("assetReservationManagement.SelectWorkspaceToSeeList") }}
      </div>
    </template>
  </v-data-table>
</template>

<script>
import { managementDatatableMixin } from "@/mixins/management/managementDatatableMixin";
import DataTableNoResults from "@/components/_Atoms/DataTableNoResults";
import ReservationsTableRow from "@/components/AssetReservationManagement/Data/ReservationsTableRow";

export default {
  name: "AssetReservationManagementReservationsTable",

  components: {
    ReservationsTableRow,
    DataTableNoResults
  },

  mixins: [managementDatatableMixin],

  props: {
    /**
     * Receives list of reservations
     */
    reservations: Array,

    /**
     * Receives the uuid the selected workspace
     */
    workspaceUuid: String,

    /**
     * Determines if the user is not admin and not super-admin
     */
    isNormalUser: Boolean,

    loading: Boolean,
  },

  data() {
    return {
      /**
       * Permission name referring to the functionality of reservation
       */
      permissionName: "asset_reservation",
      dataTableReservationId: "dataTableReservationId" ,
      paginationReservation: {
        rowsPerPage: this.getRowsFromLocalStorage("dataTableReservationId")
      },
    };
  },

  computed: {
    /**
     * Determines table headers for reservation
     * {String} value - Column key
     * {String} text - Column title
     * {String} align - Column alignment
     * {Number} width - Column width
     */
    headers() {
      return [
        {
          text: this.$i18n.t("State"),
          value: "state.main_description",
          width: "10%"
        },
        {
          text: this.$i18n.t("ExternalReference"),
          value: "ar_external_id",
          width: "18%"
        },
        {
          text: this.$i18n.t("CreationDate"),
          value: "ar_created_at",
          width: "14%"
        },
        {
          text: this.$i18n.t("AcceptanceDate"),
          value: "ar_acceptance_date",
          width: "15%"
        },
        {
          text: this.$i18n.t("InstallationDeadline"),
          value: "installation_deadline",
          width: "20%"
        },
        {
          text: this.$i18n.t("InstallationDate"),
          value: "ar_installation_date",
          width: "17%"
        },
        {
          text: this.$i18n.t("EndDate"),
          value: "ar_current_end_date",
          width: "12%"
        }
      ];
    }
  },

  methods: {
    /**
     * Determines whether the user has the permission for the action it receives
     * @param action
     * @returns {Boolean}
     */
    userHasPermissionTo(action) {
      return this.userHasFibercloudPermission(this.permissionName, action);
    },

    /**
     * Push to the page to see the selected reservation
     * @param {Object} reservation - Selected reservation
     */
    openReservation(reservation) {
      this.$emit("open-reservation", reservation.ar_uuid);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AssetReservationManagement/Data/ReservationsTable.vue